import React, { useState } from "react";
import Confetti from "react-confetti";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheck } from "react-icons/fa6";
import { httpReauest } from "../../utils/httpRequest";

const UserAchivments = ({ data, getData }) => {
  const [selectedGift, setSelectedGift] = useState(null);
  const [exploded, setExploded] = useState(false);

  const gift = [
    { name: "Novice Squire", path: "/gift/1.png", id: 1 },
    { name: "Shield Bearer", path: "/gift/2.png", id: 2 },
    { name: "Code Knight", path: "/gift/3.png", id: 3 },
    { name: "Vault Sentinel", path: "/gift/4.png", id: 4 },
    { name: "Chainbreaker", path: "/gift/5.png", id: 5 },
    { name: "Grandmaster of Trust", path: "/gift/6.png", id: 6 },
  ];

  const userLevel = data?.level || 1;

  const handleOpenGift = (item) => {
    setSelectedGift(item);
    handleSubmit(item.id);
    setTimeout(() => {
      setExploded(true);
      setTimeout(() => {
        setExploded(false);
        setSelectedGift(null);
      }, 3000); // مودال بسته بشه بعد از ۳ ثانیه
    }, 2000); // کاغذ رنگی سریع‌تر ظاهر بشه
  };

  async function handleSubmit(giftId) {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/user/gift",
      { giftId },
      { "x-access-token": user.token }
    ).then(() => {
      getData();
    });
  }

  return (
    <div className="rounded-[16px] bg-[#4A5A69] p-6 flex justify-center flex-col items-center relative shadow shadow-white/40 border border-white/10">
      <h4 className="font-bold text-[24px]">Achievements</h4>
      <div className="flex gap-4 mt-7 w-full flex-wrap justify-around">
        {gift.map((item, index) => {
          if (data?.gifts[index + 1] === true) {
            return (
              <button
                key={index}
                disabled
                className={`transition-all duration-300 flex flex-col gap-1 text-center items-center justify-center opacity-100 relative`}
              >
                <img
                  src={item.path}
                  className="w-28 xl:w-36 opacity-50"
                  alt={item.name}
                />
                <span className="font-bold text-[20px] opacity-50">
                  {item.name}
                </span>
                <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-green-600 text-[85px]">
                  <FaCheck />
                </span>
              </button>
            );
          } else {
            const isDisabled = (index + 1) >= userLevel;
            return (
              <button
                key={index}
                disabled={isDisabled}
                onClick={() => !isDisabled && handleOpenGift(item)}
                className={`transition-all duration-300 flex flex-col gap-1 text-center items-center justify-center ${
                  isDisabled ? "opacity-35" : "hover:scale-105 opacity-100"
                }`}
              >
                <img src={item.path} className="w-28 xl:w-36" alt={item.name} />
                <span className="font-bold text-[20px]">{item.name}</span>
              </button>
            );
          }
        })}
      </div>

      {/* MODAL */}
      <AnimatePresence>
        {selectedGift && (
          <motion.div
            className="fixed left-0 top-0 inset-0 z-50 flex items-center justify-center bg-black/60"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {!exploded ? (
              <motion.div
                initial={{ scale: 0.3, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.5, opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="relative flex flex-col items-center"
              >
                <img
                  src={selectedGift.path}
                  alt={selectedGift.name}
                  className="w-56 xl:w-72"
                />
                <p className="text-white font-bold text-2xl mt-4">
                  {selectedGift.name}
                </p>
              </motion.div>
            ) : (
              <div className="relative flex gap-1 items-center justify-center">
                {/* Left Half */}
                <motion.div
                  initial={{ x: 0, rotate: 0 }}
                  animate={{ x: -150, rotate: -25, opacity: 0 }}
                  transition={{ duration: 0.7 }}
                  className="overflow-hidden w-[112px] xl:w-[144px]"
                >
                  <img
                    src={selectedGift.path}
                    className="w-56 xl:w-72 object-left"
                    style={{ clipPath: "inset(0 50% 0 0)" }}
                    alt="left half"
                  />
                </motion.div>

                {/* Right Half */}
                <motion.div
                  initial={{ x: 0, rotate: 0 }}
                  animate={{ x: 150, rotate: 25, opacity: 0 }}
                  transition={{ duration: 0.7 }}
                  className="overflow-hidden w-[112px] xl:w-[144px]"
                >
                  <img
                    src={selectedGift.path}
                    className="w-56 xl:w-72 object-right"
                    style={{ clipPath: "inset(0 0 0 50%)" }}
                    alt="right half"
                  />
                </motion.div>
              </div>
            )}

            {/* Confetti */}
            {exploded && (
              <>
                <Confetti
                  width={window.innerWidth}
                  height={window.innerHeight}
                  gravity={0.3}
                />

                {/* POP-UP TEXT */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <motion.div
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className=" z-50 text-white text-xl whitespace-nowrap xl:text-5xl font-extrabold bg-gradient-to-r from-yellow-400 to-red-500 px-3 lg:px-10 py-6 rounded-2xl shadow-lg shadow-black/40"
                  >
                    Congrats, You reached lvl {selectedGift.id + 1}
                  </motion.div>
                </div>
              </>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UserAchivments;
